"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UIConfirmDialog = _interopRequireDefault(require("../dialog/UIConfirmDialog"));

var _Promptable = _interopRequireDefault(require("../decorators/Promptable"));

var _default = (0, _Promptable.default)(_UIConfirmDialog.default);

exports.default = _default;
module.exports = exports.default;